import PouchDB from 'pouchdb';
import { upsert } from './common';

const SESSION_KEY = 'XXSFsession';

class SessionStore {
  constructor(name) {
    this.db = new PouchDB(name);
  }

  set = ({ user, accessToken, instanceUrl }, onSuccess) => {
    upsert(
      this.db,
      SESSION_KEY,
      {
        _id: SESSION_KEY,
        user,
        instanceUrl,
        accessToken,
      },
      onSuccess,
    );
  };

  get = (callback) => {
    this.db
      .get(SESSION_KEY)
      .then((doc) => {
        callback(doc);
      })
      .then(() => {})
      .catch(() => callback());
  };
}

export default SessionStore;
